<template>
    <div class="user-protocol">
        <section class="section">
            <div class="section-heading">
                {{ trans('reporting.page_title.instructionsprotocol', {'name': '' })}}

                <div class="value">
                    {{ userdata.fullname }}
                </div>
            </div>
        </section>

        <div class="user-protocol__assignments">
            <assignment-protocol
                v-for="assignment in userdata.assignments" :key="assignment.id"
                :assignment="assignment"
            ></assignment-protocol>
        </div>

        <div class="page-control">
            <div class="page-control__element">
                <button type="button" @click="$emit('close')" class="btn btn--big btn--tertiary">{{ trans('buttons.back') }}</button>
            </div>

            <div class="page-control__element">
                <button
                    v-if="userdata.assignments"
                    type="button"
                    class="btn btn--tertiary"
                    @click="exportExcel()"
                >
                    {{trans('buttons.export_excel')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['user_id'],

    components: {},

    data() {
        return {
            userdata: []
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.reporting.show_user', this.user_id)).then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.userdata = data.data;
        },

        exportExcel() {
            axios({
                method: 'get',
                url: this.route('tenantapi.reporting.export.excel.user', this.user_id),
                responseType: 'blob'
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'SW_Userprotocol_'+this.userdata.lastname+'_'+this.userdata.firstname+'.xlsx');
                document.body.appendChild(link);
                link.click();
            });
        },
    }
};
</script>
